export enum REVENUE_TYPES {
  SellTo = 'sellTo',
  SellThru = 'sellThru',
}
